import GraphItem from "../GraphItem";
import { GraphConfiguration } from "@/type/common";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import AuthContext from "@/store/contexts/AuthContext";
import { loadData } from "@/lib/load-data";
import { refactor_config } from "@/utils/refactor";

const GraphItemLoader = ({ id, editing }: { id: string; editing: boolean }) => {
  const { configs, models } = useContext(AuthContext);

  const [config, setConfig] = useState<GraphConfiguration | null>(null);
  const [data, setData] = useState<any[]>([]);
  const [metadata, setMetadata] = useState<any>(null);
  const loadedConfig = useRef<string | null>(null);

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const config = configs.find((c) => c.id === id);
    setConfig(config || null);
  }, [id, configs]);

  useEffect(() => {
    if (!config || loadedConfig.current === JSON.stringify(config)) {
      return;
    }
    loadData(refactor_config(config)).then((data) => {
      if (!data || data.length === 0) return;
      const obj = data[0];
      const result = obj[Object.keys(obj)[0]];
      setData(result.data || []);
      setMetadata(result.metadata || null);
      loadedConfig.current = JSON.stringify(config);
      setLoaded(true);
    });
  }, [config]);

  const emptyConfig = useMemo(() => ({} as GraphConfiguration), []);

  return (
    <GraphItem
      config={config || emptyConfig}
      data={data}
      metadata={metadata}
      models={models}
      loaded={loaded}
    />
  );
};

export default GraphItemLoader;
